import * as RadixTooltip from '@radix-ui/react-tooltip';
import { PropsWithChildren, ReactNode } from 'react';

import Text from '../Text';

import * as Styled from './index.styles';

export interface TooltipProps {
  /** 말풍선 안에 들어갈 내용 */
  content: ReactNode;
  side?: RadixTooltip.TooltipContentProps['side'];
  align?: RadixTooltip.TooltipContentProps['align'];
  sideOffset?: number;
  /** 노출까지의 지연(ms). 아이콘 버튼처럼 라벨이 없는 트리거는 0을 권장한다. */
  delayDuration?: number;
}

/**
 * 임의의 요소를 트리거로 감싸는 범용 툴팁.
 * 아이콘 하나에만 붙이는 경우엔 IconTooltip을 쓴다.
 *
 * children은 ref를 넘겨받을 수 있는 단일 요소여야 한다(asChild).
 * hover/focus/ESC 처리는 Radix에 맡겨 키보드 사용자도 동일하게 볼 수 있게 한다.
 */
export const Tooltip = ({
  content,
  side = 'top',
  align = 'center',
  sideOffset = 8,
  delayDuration = 0,
  children,
}: PropsWithChildren<TooltipProps>) => {
  return (
    <RadixTooltip.Provider>
      <RadixTooltip.Root delayDuration={delayDuration}>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <Styled.TooltipContent
            side={side}
            align={align}
            sideOffset={sideOffset}
          >
            <Styled.ContentWrapper>
              <Text variant="sm-medium" color="white" textAlign="center">
                {content}
              </Text>
            </Styled.ContentWrapper>
          </Styled.TooltipContent>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
};

export default Tooltip;

export * from './IconTooltip';
